module.exports = __webpack_public_path__ + "static/3BHK-04-Master-Bedroom-65dada807d58c20036e0acef9d8378ec.jpg";